function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90 0H0V59.9987H90V0Z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4554 23.1064L46.5481 27.3684L51.5566 25.7444L48.4592 30.0025L51.5515 34.2642L46.5446 32.634L43.4471 36.8923L43.4503 31.6267L38.4434 29.9964L43.4521 28.3723L43.4554 23.1064Z",
  fill: "#F0F0F0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.016 40.6519C29.1328 40.6519 24.3633 35.8824 24.3633 29.9992C24.3633 24.116 29.1328 19.3465 35.016 19.3465C36.8505 19.3465 38.5763 19.8104 40.0833 20.6269C37.7194 18.315 34.4864 16.8882 30.9189 16.8882C23.678 16.8882 17.8081 22.7582 17.8081 29.999C17.8081 37.2398 23.6781 43.1098 30.9189 43.1098C34.4864 43.1098 37.7194 41.683 40.0833 39.3711C38.5765 40.188 36.8505 40.6519 35.016 40.6519Z",
  fill: "#F0F0F0"
});

var SvgTry = function SvgTry(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTry, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TRY.fcf82ba7.svg";
export { ForwardRef as ReactComponent };